import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { LoaderModule, TranslateModule } from '@xref/ngx';

import { RegSetUpComponent } from './set-up.component';

@NgModule({
    declarations: [RegSetUpComponent],
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        LoaderModule,
        MatSelectModule
    ],
    exports: [RegSetUpComponent],
})
export class RegSetUpModule {}
